import { type AppConfig } from './types';

export const defaultConfig: AppConfig = {
	title: 'My ChatBot',
	chatBotName: 'ChatBot',
	chatBotAvatar: '',
	minimizedIcon: '',
	welcomeMessage: 'Welcome to the chat bot!',
	expandChatText: 'How can I help you?',
	minimizedChatText: 'Minimize',
	baseUrl: 'https://example.com',
	humanHandoverUrl: '/',
	theme: {
		font: 'sans-serif',
		primary: {
			color: '#475760',
			textColor: '#FFFFFF',
		},
		secondary: {
			color: '#FFFFFF',
			textColor: '#2D2C26',
		},
	},
};
